import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { LandingPageManager } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/landing-pages")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <LandingPageManager />
    </RouteGuard>
  ),
});
